// use-sign-in-with-apple.ts — Auth suite, action
//
// Initiates Apple OAuth via Supabase (redirect-based — the response is not seen here;
// the user lands at /auth/callback after Apple redirects back).

'use client';

import { useMemo } from 'react';
import { supabase } from '@/lib/supabase';
import { useActionHook } from '@/lib/query/use-action-hook';
import type { ActionResult } from '@/types/async-protocol';

const APPLE_AUTH_PROVIDER = 'apple';

export function useSignInWithApple(): ActionResult<void, void> {
  return useActionHook<void, void>(
    useMemo(
      () => ({
        mutationFn: async () => {
          const { error } = await supabase.auth.signInWithOAuth({
            provider: APPLE_AUTH_PROVIDER,
            options: { redirectTo: `${window.location.origin}/auth/callback` },
          });
          if (error) throw error;
        },
      }),
      [],
    ),
  );
}
